export const FirebaseConfig = {
	"projectId": "ninhthuangotx",
	"appId": "1:890443835515:web:74836ae20d2cc996235ade",
	"databaseURL": "https://ninhthuangotx-default-rtdb.firebaseio.com",
	"storageBucket": "ninhthuangotx.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyCD__yOliXAcYEzPz30zyb1I_y9i0HRCmU",
	"authDomain": "ninhthuangotx.firebaseapp.com",
	"messagingSenderId": "890443835515",
	"measurementId": "G-T3W3X1R999"
};